// reducer.js
import { createReducer } from '@reduxjs/toolkit';
import { setNextPageId, setPrevPageId } from './actions';

const initialState = {
  nextPageId: 1, // Initial value for nextPageId
  prevPageId: 0, // Initial value for prevPageId
};

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setNextPageId, (state, action) => {
      state.nextPageId = action.payload;
    })
    .addCase(setPrevPageId, (state, action) => {
      state.prevPageId = action.payload;
    });
});

export default reducer;
